import _ from 'lodash'
import React from 'react';
import { Link } from 'react-router-dom'

const renderIconClose = () => { 
	return (
	  <p className="dpto-item-icon">
	    <i className="material-icons">arrow_right</i>
	  </p>
  ) 
}
const renderIconOpend = () => { 
	return (
	  <p className="dpto-item-icon">
	    <i className="material-icons">arrow_drop_down</i>
	  </p>
  ) 
}
const renderIconSlash = () => { 
	return (
	  <p className="dpto-item-icon">/</p>
	) 
}

const MenuItem = (props) => {
  const {
  	item, 
  	functions,
  	mainid, 
  	menu, 
  	selected, 
  	st_addit, 
  	st_eddit
  } = props;
  const current_modl = _.find(menu, {_id: selected})
  const current_path = current_modl ? current_modl.path : ""    
  const item_selectd = current_path.startsWith(`${item.path}/`) || current_path === item.path
  const item_clsstrg = item_selectd ? ` visible` : ` `
  
  const is_over = (!st_addit && item._id === selected)
  const string_selected = is_over ? ` selected` : ``
  const nfield_visibles = st_addit ? ` visible` : ` `
  const parent_havesubs = _.filter(menu, {parent: item._id})
  // console.log(item.path)
  if(st_eddit && is_over)
  	return (
      <div className="dpto-newf">
  			{ functions.renderField(item._id) }
      </div>
		)
  return (
    <div className={`dpto-item${item_clsstrg}${string_selected}`}>
      <div className="dpto-wrap" onClick={() => functions.handleSelected(item._id)}>
        <div className="dpto-wrap-left">
          { 
            parent_havesubs.length > 0 ? 
              item_selectd ? 
                renderIconOpend() : 
                  renderIconClose() : 
                    renderIconSlash() 
          }
        </div>
        <div className="dpto-wrap-center">{item.name.toUpperCase()}</div>
        <div className="dpto-wrap-right">
          { is_over && 
            <Link to={`/${item.path}`} onClick={() => functions.handleClea() && functions.handleMenu()}>
              <i className="material-icons">open_in_new</i> 
            </Link>
          }
        </div>
      </div>
      <div className="dpto-subs">
        { functions.renderSubs(item._id) }
        <div className={`dpto-newf${nfield_visibles}`}>
          { 
          	(item._id === selected || mainid === selected) && 
          	st_addit && functions.renderField(item._id) 
          }
        </div>
      </div>
    </div>
  )
}

export default MenuItem;